import DOMAIN_ICONS from "@/Components/Icons/DomainIcons";
import HandshakeIcon from "@/Components/Icons/HandshakeIcon.vue";
import SHARE_ICONS from "@/Components/Icons/ShareIcons";
import { markRaw } from "vue";

export const ROUTES = Object.freeze({
    ADVISOR: {
        TIPS: "/ratgeber/lemonswan-tipps/online-profil/",
        PARTNER_SEARCH: "/ratgeber/lemonswan-tipps/sucheinstellungen/",
        CONTACT: "/ratgeber/lemonswan-tipps/erste-nachricht/",
        FIRST_DATES: "/ratgeber/erstes-date/",
        SINGLES: "/ratgeber/single-staedte/",
        INTERVIEWS: "/ratgeber/experteninterview/",
    },
});

export const EMAIL_PROVIDERS = [
    {
        text: "Zu Gmail",
        value: "gmail",
        link: "https://mail.google.com/mail/u/#search/from%3A(news@lemonswan.com)",
        prependIcon: markRaw(DOMAIN_ICONS.GmailIcon),
    },
    {
        text: "Zu Gmail",
        value: "googlemail",
        link: "https://gmail.com/",
        prependIcon: markRaw(DOMAIN_ICONS.GmailIcon),
    },
    {
        text: "Zu Web.de",
        value: "web",
        link: "https://web.de/",
        prependIcon: markRaw(DOMAIN_ICONS.WebDeIcon),
    },
    {
        text: "Zu Outlook",
        value: "outlook",
        link: "https://login.live.com/",
        prependIcon: markRaw(DOMAIN_ICONS.OutlookIcon),
    },
    {
        text: "Zu Hotmail",
        value: "hotmail",
        link: "https://login.live.com/",
        prependIcon: markRaw(DOMAIN_ICONS.OutlookIcon),
    },
    {
        text: "Zu MSN",
        value: "msn",
        link: "https://login.live.com/",
        prependIcon: markRaw(DOMAIN_ICONS.OutlookIcon),
    },
    {
        text: "Zu Yahoo",
        value: "yahoo",
        link: "https://login.yahoo.com/",
        prependIcon: markRaw(DOMAIN_ICONS.YahooIcon),
    },
    {
        text: "Zu freenet",
        value: "freenet",
        link: "https://www.freenet.de/",
        prependIcon: markRaw(DOMAIN_ICONS.FreenetIcon),
    },
    {
        text: "Zu t-online",
        value: "t-online",
        link: "https://email.t-online.de/",
        prependIcon: markRaw(DOMAIN_ICONS.TOnlineIcon),
    },
    {
        text: "Zu Magenta",
        value: "magenta",
        link: "https://email.t-online.de/",
        prependIcon: markRaw(DOMAIN_ICONS.TOnlineIcon),
    },
    {
        text: "Zu GMX",
        value: "gmx",
        link: "https://www.gmx.net/",
        prependIcon: markRaw(DOMAIN_ICONS.GmxIcon),
    },
    {
        text: "Zu Aol",
        value: "aol",
        link: "https://login.aol.com/",
        prependIcon: markRaw(DOMAIN_ICONS.AolIcon),
    },
    {
        text: "Zu Apple Mail",
        value: "icloud",
        link: "https://www.icloud.com/mail",
        prependIcon: markRaw(DOMAIN_ICONS.AppleMailIcon),
    },
    {
        text: "Zu mail.com",
        value: "mail",
        link: "https://www.mail.com/",
        prependIcon: markRaw(DOMAIN_ICONS.MailComIcon),
    },
];

export const EMAIL_ADDRESSES = Object.freeze({
    SERVICE: "tuersteherinnen@lemonswan.com",
});

export const COUNTRY_AREA_CODES = Object.freeze({
    DE: "+49",
    AT: "+43",
    CH: "+41",
    LU: "+352",
    NL: "+31",
    BE: "+32",
    ES: "+34",
    FR: "+33",
    DK: "+45",
});

export const APP_CONFIG = Object.freeze({
    NAME: "LemonSwan",
    LOCATION: "Hamburg",
});

export const TOAST_STATES = {
    SUCCESS: "success",
    ERROR: "error",
};

export const LIMIT_FOR_PHOTOS_UPLOAD = 9;

export const MESSENGER_AND_EMAIL_LINKS = [
    {
        network: "email",
        label: "referral_area.sharing.modal.icon_labels.email",
        prependIcon: markRaw(SHARE_ICONS.LetterInCircleIcon),
    },
    {
        network: "whatsapp",
        label: "referral_area.sharing.modal.icon_labels.whats_app",
        prependIcon: markRaw(SHARE_ICONS.WhatsappLogo),
    },
    {
        network: "messenger",
        label: "referral_area.sharing.modal.icon_labels.messenger",
        prependIcon: markRaw(SHARE_ICONS.FacebookMessengerIcon),
        directUrl: "https://www.messenger.com/",
    },
];

export const SOCIAL_MEDIA_LINKS = [
    {
        network: "facebook",
        label: "referral_area.sharing.modal.icon_labels.facebook",
        prependIcon: markRaw(SHARE_ICONS.FacebookIcon),
    },
];

export const NOTIFICATION_FORM_CARD_ITEMS = [
    {
        key: "notifications_of_partners",
        leftHandItems: [
            {
                key: "new_prospects",
                label: "ls_my_profile_data_and_settings_communication_setting3",
            },
            {
                key: "profile_content_enquiries",
                label: "ls_my_profile_data_and_settings_communication_setting14",
            },
            {
                key: "smiles_and_likes",
                label: "ls_my_profile_data_and_settings_communication_setting2",
            },
            {
                key: "welcomes_messages",
                label: "ls_my_profile_data_and_settings_communication_setting7",
            },
            {
                key: "question_game",
                label: "ls_my_profile_data_and_settings_communication_setting19",
            },
        ],
        rightHandItems: [
            {
                key: "new_messages",
                label: "ls_my_profile_data_and_settings_communication_setting1",
            },
            {
                key: "compliments",
                label: "ls_my_profile_data_and_settings_communication_setting15",
            },
            {
                key: "roses",
                label: "ls_my_profile_data_and_settings_communication_setting16",
            },
            {
                key: "exclusive_messages",
                label: "ls_my_profile_data_and_settings_communication_setting17",
            },
        ],
    },
    {
        key: "proposals_and_matching",
        leftHandItems: [
            {
                key: "suitable_partner_suggestions",
                label: "ls_my_profile_data_and_settings_communication_setting4",
            },
        ],
        rightHandItems: [
            {
                key: "rating_reminder",
                label: "ls_my_profile_data_and_settings_communication_setting12",
            },
        ],
    },
    {
        key: "notifications_of_favorites",
        leftHandItems: [
            {
                key: "favorite_update",
                label: "ls_my_profile_data_and_settings_communication_setting9",
            },
        ],
        rightHandItems: [],
    },
    {
        key: "horoscope",
        leftHandItems: [
            {
                key: "daily_horoscope",
                label: "ls_my_profile_data_and_settings_communication_setting13",
            },
        ],
        rightHandItems: [],
    },
    {
        key: "notifications_of_balances",
        leftHandItems: [
            {
                key: "spotlight",
                label: "ls_my_profile_data_and_settings_communication_setting11",
            },
        ],
        rightHandItems: [
            {
                key: "coins",
                label: "ls_my_profile_data_and_settings_communication_setting18",
            },
        ],
    },
    {
        key: "tips_and_information",
        leftHandItems: [
            {
                key: "tips_for_your_partner_search",
                label: "ls_my_profile_data_and_settings_communication_setting5",
            },
            {
                key: "weekly_summary",
                label: "ls_my_profile_data_and_settings_communication_setting10",
            },
        ],
        rightHandItems: [
            {
                key: "newsletter",
                label: "ls_my_profile_data_and_settings_communication_setting6",
            },
            {
                key: "attractive_offers",
                label: "ls_my_profile_data_and_settings_communication_setting8",
            },
        ],
    },
];

export const PUSH_NOTIFICATION_FORM_CARD_ITEMS = [
    {
        key: "notifications_of_partners",
        leftHandItems: [
            {
                key: "profile_content_enquiries",
                label: "ls_my_profile_data_and_settings_communication_setting14",
            },
            {
                key: "smiles_and_likes",
                label: "ls_my_profile_data_and_settings_communication_setting2",
            },
            {
                key: "compliments",
                label: "ls_my_profile_data_and_settings_communication_setting15",
            },
            {
                key: "question_game",
                label: "ls_my_profile_data_and_settings_communication_setting19",
            },
        ],
        rightHandItems: [
            {
                key: "new_messages",
                label: "ls_my_profile_data_and_settings_communication_setting1",
            },
            {
                key: "roses",
                label: "ls_my_profile_data_and_settings_communication_setting16",
            },
            {
                key: "exclusive_messages",
                label: "ls_my_profile_data_and_settings_communication_setting17",
            },
        ],
    },
    {
        key: "proposals_and_matching",
        leftHandItems: [
            {
                key: "rating_reminder",
                label: "ls_my_profile_data_and_settings_communication_setting12",
            },
        ],
        rightHandItems: [],
    },
    {
        key: "notifications_of_favorites",
        leftHandItems: [
            {
                key: "favorite_update",
                label: "ls_my_profile_data_and_settings_communication_setting9",
            },
        ],
        rightHandItems: [],
    },
    {
        key: "notifications_of_balances",
        leftHandItems: [
            {
                key: "spotlight",
                label: "ls_my_profile_data_and_settings_communication_setting11",
            },
        ],
        rightHandItems: [
            {
                key: "coins",
                label: "ls_my_profile_data_and_settings_communication_setting18",
            },
        ],
    },
];

export const INCOGNITO_EXPLANATION_TEXT_ITEMS = [
    {
        header: "profile.incognito_modal.explanation_header_1",
        text: "profile.incognito_modal.explanation_text_1",
    },
    {
        header: "profile.incognito_modal.explanation_header_2",
        text: "profile.incognito_modal.explanation_text_2",
    },
    {
        header: "profile.incognito_modal.explanation_header_3",
        text: "profile.incognito_modal.explanation_text_3",
    },
];

export const FILTER_OPTIONS = Object.freeze({
    premiumStates: [
        { text: "Non Premium", value: "non_premium" },
        { text: "Potential Premium Free", value: "potential_premium_free" },
        { text: "Premium Free Pending", value: "premium_free_pending" },
        { text: "Premium Free", value: "premium_free" },
        { text: "Premium Paid", value: "premium" },
        { text: "Premium Trial", value: "premium_trial" },
    ],
    accountStates: [
        { text: "Banned", value: "banned" },
        { text: "Not Banned", value: "not_banned" },
        { text: "Reported", value: "reported" },
        { text: "Deactivated", value: "deactivated" },
        { text: "Deleted", value: "deleted" },
    ],
    scamIndicators: [
        { text: "Message Limit Reached", value: "flagged_for_too_many_chats" },
        {
            text: "Too Many Messages/Minute",
            value: "flagged_for_too_many_first_messages",
        },
        { text: "Browser Lang", value: "has_spammer_browser_language" },
        { text: "No CID", value: "does_not_have_cid" },
        { text: "Pay By Transfer", value: "purchase_via_transfer" },
        { text: "Time To Purchase", value: "purchase_too_soon" },
        { text: "Purchase w/o Promo", value: "purchase_without_promo" },
        { text: "Deactivated Early", value: "deactivated_too_early" },
        { text: "Too many Rejections", value: "too_many_rejections" },
        { text: "Duplicate Phone", value: "duplicate_phone_number" },
        {
            text: "Notifications Off",
            value: "notifications_toggled_after_register",
        },
        { text: "Question Game Copy Paste", value: "question_game_copy_paste" },
    ],
});
